import AirbnbIcon from '@assets/images/review-source-airbnb.svg';
import RoveIcon from '@assets/images/review-source-rove.svg';
import BookingComIcon from '@assets/images/review-source-booking-com.svg';
import VRBOIcon from '@assets/images/review-source-vrbo.svg';
import { ListingUserReviewType } from '@utils/types/review';

export const INIT_REVIEW_COUNT = 6;

export const getSourceIcon = (source: ListingUserReviewType['source']) => {
  switch (source) {
    case 'airbnb2':
      return AirbnbIcon;
    case 'homeaway2':
      return VRBOIcon;
    case 'bookingCom':
      return BookingComIcon;
    case null:
    default:
      return RoveIcon;
  }
};
